import './style/dnb-array-selection.scss'
